import studentServiceCenterImage from '@/assets/themes/stanford/images/student-service-center.jpg'
import financialAidImage from '@/assets/themes/stanford/images/financial-aid.jpg'
import eLearningImage from '@/assets/themes/stanford/images/eLearning.jpg'

export const recommendedPages = [
  {
    title: 'Student Services Center',
    descriptiopn:
      'We’re here to help you and your family navigate your academic journey. Think of us as your go-to partner and lean on us to answer questions about enrollment, academic policies, tuition and fees, and more.<br /> Reach out to us through one of these four options:',
    image: studentServiceCenterImage,
    cta: [
      {
        label: 'Submit an online request',
        url: 'https://stanford.service-now.com/student_services',
      },
      {
        label: 'Make a virtual Zoom appointment',
        url: 'https://go.oncehub.com/StudentServicesCenterSSC',
      },
      {
        label: 'Chat with us live',
        url: 'https://stanford.service-now.com/student_services',
      },
      {
        label: 'Give us a call: (866) 993-7772',
        url: 'tel:8669937772',
      },
    ],
  },
  {
    title: 'Financial Aid',
    descriptiopn:
      'At Stanford, we are committed to providing a comprehensive need-based financial aid program that makes it financially possible for admitted students to attend. Learn more about <a href="https://financialaid.stanford.edu/" target="_blank">funding options</a> available for your undergraduate or graduate education at Stanford.',
    image: financialAidImage,
  },
  {
    title: 'Experiential Learning',
    descriptiopn:
      'Stanford On & Off-Campus Learning Opportunities (SOLO) provides a single place for you to both find and apply for experiential learning opportunities, including internships, public service, and research endeavors. Visit <a href="https://solo.stanford.edu/" target="_blank">SOLO</a> to learn more. ',
    image: eLearningImage,
  },
]
